import type { AlignmentStatus } from '../types/metro';

/**
 * CEW design tokens mirrored from `tailwind.config.ts` for use in JS code
 * (Leaflet markers, chart colors, etc.) where Tailwind classes don't apply.
 *
 * Keep this in sync with `tailwind.config.ts` — the source of truth for the
 * design system lives in `_archive/shared.css` and `_archive/home.html`.
 */
export const COLORS = {
  navy: '#144175',
  blue: '#0074CC',
  gold: '#F9A21C',
  rose: '#C6354C',
  teal: '#266150',
  green: '#27AE60',
  green2: '#1d8348',
  ice: '#EAF4F9',
  surface: '#f5f6f8',
  white: '#ffffff',
  border: '#e2e4e8',
} as const;

/**
 * Status threshold for the credential-to-job ratio.
 *
 * DEC-056 (FINAL) collapsed the legacy 3-band split (shortageBelow
 * 0.8, surplusAbove 1.2) into a single binary cut at 1.0. Ratios
 * BELOW 1.0 are shortage; ratios AT OR ABOVE 1.0 are surplus.
 * The midband 'balanced' state is gone.
 */
export const STATUS_THRESHOLDS = {
  surplusFrom: 1.0,
} as const;

/**
 * Color per status — used by Leaflet markers and badges.
 *
 * LUIS-fix-1: surplus changed from `COLORS.blue` to `COLORS.green2` per
 * Luis's May 6 directive ("made surpluss gren as it was on their og
 * report"). The Georgetown reference report uses green for surplus —
 * blue was an early prototype mistake. Cascades to bubbles, tooltips,
 * popup, legend, and the rankings severity pill.
 */
export const STATUS_COLOR: Record<AlignmentStatus, string> = {
  shortage: COLORS.rose,
  surplus: COLORS.green2,
} as const;

/**
 * Routes — single source of truth shared by the router, navbar, and any
 * link in the app. V1 ships only Home / Map / Rankings; Detail / Compare /
 * Providers are deferred (see `.claude/epics/SCOPE.md`).
 */
export const ROUTES = {
  home: '/',
  map: '/map',
  rankings: '/rankings',
  detail: '/detail',
  compare: '/compare',
  providers: '/providers',
} as const;
